import React from "react";

const BtnModalDiscount = ({ openDiscount, setOpenDiscount, discountList, setDiscountList }) => {
    // Handle closing the modal
    const handleClose = () => setOpenDiscount(false);

    // Handle adding a new set of fields
    const handleAddMore = () => {
        setDiscountList([...discountList, { name: "", value: "" }]);
    };

    // Handle removing a set of fields
    const handleRemove = (index) => {
        const updatedList = [...discountList];
        updatedList.splice(index, 1);
        setDiscountList(updatedList);
    };

    // Handle saving the fields to the state and closing the modal
    const handleSave = () => {
        console.log("Saved Data: ", discountList);
        handleClose(); // Close the modal after saving
    };

    // Handle input changes
    const handleInputChange = (index, field, value) => {
        const updatedList = [...discountList];
        updatedList[index][field] = value;
        setDiscountList(updatedList);
    };

    return (
        openDiscount && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl overflow-hidden">
                    <div className="flex justify-between items-center px-6 py-4 border-b">
                        <h2 className="text-xl font-semibold">Extra Discount</h2>
                        <button
                            onClick={handleClose}
                            className="text-gray-4 hover:text-gray-800"
                        >
                            ✖
                        </button>
                    </div>
                    <div className="px-6 py-4 max-h-[480px] overflow-y-auto">
                        {discountList.map((discount, index) => (
                            <div key={index} className="space-y-4">
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block mb-1 font-medium text-gray-700">
                                            Discount Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Discount Name"
                                            value={discount.name}
                                            onChange={(e) =>
                                                handleInputChange(index, "name", e.target.value)
                                            }
                                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label className="block mb-1 font-medium text-gray-700">
                                            Discount Value
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Discount Value"
                                            value={discount.value}
                                            onChange={(e) =>
                                                handleInputChange(index, "value", e.target.value)
                                            }
                                            className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        />
                                    </div>
                                </div>
                                {discountList.length > 1 && (
                                    <div className="flex justify-start">
                                        <button
                                            onClick={() => handleRemove(index)}
                                            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                                        >
                                            Remove
                                        </button>
                                    </div>
                                )}
                            </div>
                        ))}
                        <div className="flex justify-end mt-4">
                            <button
                                onClick={handleAddMore}
                                className="px-4 py-2 bg-[#8ec639] text-white rounded hover:bg-green-00"
                            >
                                Add More
                            </button>
                        </div>
                    </div>
                    <div className="flex justify-between items-center px-6 py-4 border-t">
                        <button
                            className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300 focus:outline-none"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                        <button
                            onClick={handleSave}
                            className="px-4 py-2 bg-[#8ec639] text-white rounded hover:bg-green-400"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default BtnModalDiscount;
